// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_927a99ad28--wrapper--sW6LX","border":"_927a99ad28--border--V8pjo"};